import React from 'react'
import { TextField, makeStyles } from '@material-ui/core'
import NUMBER_INPUT_STYLES from '../../../utils/constants/CSS/numberInputStyles'

const useStyles = makeStyles(NUMBER_INPUT_STYLES)

const StyledNumberField = ({
  label,
  value,
  onChange,
  error,
  step,
  min,
  max,
  inputProps,
  ...props
}) => {
  const classes = useStyles()

  return (
    <TextField
      {...props}
      fullWidth
      autoComplete='off'
      variant='standard'
      type='number'
      label={label}
      value={value}
      onChange={onChange}
      error={Boolean(error)}
      helperText={error}
      inputProps={{
        step,
        min,
        max,
        ...inputProps,
      }}
      InputProps={{
        classes: {
          root: classes.root,
          input: classes.input,
        },
        disableUnderline: true,
      }}
      InputLabelProps={{
        classes: {
          error: classes.error,
          shrink: classes.shrink,
          formControl: classes.formControl,
        },
      }}
      FormHelperTextProps={{
        classes: {
          root: classes.helperTextRoot,
        },
      }}
    />
  )
}

export default StyledNumberField
